import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router';
import { useAuthStore } from '../store/authStore';

export const Home = () => {
  const { user, isAuthenticated, initialize } = useAuthStore();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // Testimonials data
  const testimonials = [
    {
      id: 1,
      name: "Nguyễn Tuấn Duy",
      role: "Học sinh lớp 9A6 niên khoá 2018-2022, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/1.jpg",
      color: "from-blue-500 to-indigo-600",
      content: "Cô ơi con được hẳn 10 tiếng anh luôn ạ! Con cảm ơn cô rất là nhiều vì luôn đồng hành cùng con. Con nghĩ cô là người làm thay đổi con nhất để con có được như ngày hôm nay. Lúc mới vào lớp 6 trường mình, con thi đầu vào có 6 điểm anh con nát nhất lớp í cô ơi. Cô là người truyền đạt cho con những cái đó, cô còn ân cần đến nỗi cho con ở lại học thêm sau giờ hay giải thích cho con mà còn không khó chịu gì cả, con rất biết ơn vì điều ấy ạ. Con cũng không học thêm tiếng anh gì con cũng chẳng ôn gì trước khi thi, nên con nghĩ là điểm 10 này là tặng cho cô cô nhé!"
    },
    {
      id: 2,
      name: "Nguyễn Ngọc Hải Yến",
      role: "Học sinh lớp 9A6 niên khoá 2018-2022, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/2x.jpg",
      color: "from-green-500 to-teal-600",
      content: "Cô là cô giáo dạy tiếng Anh đỉnh nhất mà con từng học. Con chưa gặp ai mà dạy dễ hiểu rồi hiểu tâm lí học sinh đến vậy luôn á cô!"
    },
    {
      id: 3,
      name: "Phạm Đỗ Minh Hiếu",
      role: "Học sinh lớp 12D3 niên khoá 2022-2025, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/3.jpg",
      color: "from-purple-500 to-pink-600",
      content: "Cô ơi con được 9 điểm thi THPT. Cảm ơn cô hai năm vừa qua đã tận tình giúp đỡ, dạy dỗ con. Nhờ cô truyền động lực nên con mới có niềm vui khi học tiếng anh cô ạ, con quý cô Loan rất nhiềuuuuuu ạ"
    },
    {
      id: 4,
      name: "Phạm Hoàng Nhật Vy",
      role: "Học sinh lớp 12D3 niên khoá 2022-2025, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/4.jpg",
      color: "from-orange-500 to-red-600",
      content: "Cô ơi may quá giai đoạn cuối có bộ đề của cô cho con ôn. Có ăn cơm với làm bộ đề của cô mà con cũng được 9 điểm dù đề năm nay khó. Cô dã dạy giỏi, siêu bao dung lại còn hài hước cơ. Con cảm ơn cô nhiều lắm ạ."
    },
    {
      id: 5,
      name: "Hà Huy Nhật Minh",
      role: "Học sinh lớp 12D3 niên khoá 2022-2025, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/5.jpg",
      color: "from-indigo-500 to-purple-600",
      content: "Nhờ có cô truyền động lực cho con trong học tập, nhất là môn Tiếng Anh mà con đã quyết tâm thi SAT và được 1550 SAT hehe. Cô luôn trợ giúp, giúp đỡ con dù là chuyện gì."
    },
    {
      id: 6,
      name: "Nguyễn Diệu Ngọc",
      role: "Học sinh lớp 12D3 niên khoá 2022-2025, Trường THCS và THPT Nguyễn Tất Thành",
      avatar: "/images/6.jpg",
      color: "from-indigo-500 to-purple-600",
      content: "Cô Loan trong mắt con luôn là người nói ít, làm nhiều, nhưng chính những hành động, sự để tâm đến các chi tiết hàng ngày của học sinh và muốn trợ giúp hết sức mình của cô đã khiến con yêu cô ngày càng nhiều, cũng như nhận ra giá trị, phẩm chất đáng quý của Nhà Giáo."
    }
  ];

  // Carousel navigation functions
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  }, [testimonials.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  }, [testimonials.length]);

  const goToSlide = useCallback((index: number) => {
    setCurrentSlide(index);
  }, []);

  // Auto-play functionality
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [nextSlide]);

  const getDisplayName = () => {
    if (!user) return '';

    if (user.role === 'admin') {
      return 'Admin';
    }

    // For students, use their actual name if available, otherwise use username
    return user.student_name || user.username;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <h1 className="text-xl font-bold text-gray-900">Cô Loan Tiếng Anh</h1>
            </div>
            <div className="flex items-center">
              {isAuthenticated ? (
                <span className="text-gray-700">
                  Hi, <Link
                    to={user?.role === 'admin' ? '/dashboard' : `/students/${user?.student_id}`}
                    className="font-medium text-blue-600 hover:text-blue-800 cursor-pointer underline"
                  >
                    {getDisplayName()}
                  </Link>
                </span>
              ) : (
                <Link
                  to="/login"
                  className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
                >
                  Đăng nhập
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Introduction Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
            {/* Images Section - Left */}
            <div className="mb-12 lg:mb-0">
              <div className="relative">
                <img
                  src="/images/intro.jpeg"
                  alt="English Excellence Academy Introduction"
                  className="w-full h-auto object-contain rounded-lg shadow-lg"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
              </div>
            </div>

            {/* Info Section - Right */}
            <div className="lg:pl-8">
              <div className="bg-gray-50 rounded-lg p-8 shadow-sm">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-8">
                  Giới thiệu về giáo viên
                </h2>
                <div className="space-y-4 text-gray-700">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-2 h-2 bg-blue-600 rounded-full mt-2 mr-4"></div>
                    <p className="text-lg font-semibold">Cô Trần Thị Thuý Loan</p>
                  </div>

                  <div className="pl-6 space-y-3">
                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Giáo viên Tiếng Anh trường THCS & THPT Nguyễn Tất Thành, ĐHSPHN
                    </p>

                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Thạc sĩ ngành Lí Luận và Phương Pháp Giảng Dạy Tiếng Anh - Đại học Ngoại Ngữ, ĐHQGHN
                    </p>

                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Cựu HS Chuyên Anh - THPT Chuyên Ngoại Ngữ, ĐHNN, ĐHQGHN
                    </p>

                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Có 10 năm kinh nghiệm luyện thi các cấp 1-2-3, đặc biệt 100% HS điểm thi đạt 9 trở lên trong kì thi vào 10 (Niên khoá 2018-2021)
                    </p>

                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Năm 2025 có học sinh đạt điểm trung bình môn Tiếng Anh tốt nghiệp THPT xếp thứ 4 toàn thành phố Hà Nội
                    </p>

                    <p className="flex items-start">
                      <span className="text-blue-600 mr-2">•</span>
                      Có phương pháp dạy tích cực, truyền cảm hứng cho học sinh, giảng dạy chuyên sâu và rèn luyện tính chuyên cần cho học sinh, được nhiều phụ huynh và học sinh tin yêu
                    </p>
                  </div>
                </div>

                <div className="mt-8">
                  {isAuthenticated ? (
                    <Link
                      to={user?.role === 'admin' ? '/dashboard' : `/students/${user?.student_id}`}
                      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                    >
                      Vào hệ thống học tập
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition-colors"
                    >
                      Truy cập hệ thống học tập
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}

      {/* Course Categories Section */}


      {/* Testimonials Section */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase"></h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Những phản hồi từ học sinh và phụ huynh
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              Nghe những chia sẻ chân thật từ học sinh và phụ huynh về hành trình học tập cùng cô Loan
            </p>
          </div>

          {/* Testimonials Carousel */}
          <div className="mt-16 relative">
            {/* Carousel Container */}
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-blue-50 to-indigo-50 p-8">
              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 hover:bg-gray-50 transition-all duration-200 group"
                aria-label="Previous testimonial"
              >
                <svg className="w-6 h-6 text-gray-600 group-hover:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>

              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg rounded-full p-3 hover:bg-gray-50 transition-all duration-200 group"
                aria-label="Next testimonial"
              >
                <svg className="w-6 h-6 text-gray-600 group-hover:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>

              {/* Slides Container */}
              <div className="flex transition-transform duration-500 ease-in-out" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="w-full flex-shrink-0">
                    <div className="max-w-4xl mx-auto">
                      {/* Testimonial Card */}
                      <div className="bg-white rounded-xl shadow-xl p-8 lg:p-12 mx-4">
                        <div className="text-center">
                          {/* Avatar */}
                          <div className="flex justify-center mb-6">
                            <div className={`h-20 w-20 bg-gradient-to-r ${testimonial.color} rounded-full flex items-center justify-center shadow-lg`}>
                              {/* <span className="text-white font-bold text-2xl">{testimonial.avatar}</span> */}
                              <img src={testimonial.avatar} />
                            </div>
                          </div>

                          {/* Stars */}
                          <div className="flex justify-center mb-6">
                            {[...Array(5)].map((_, i) => (
                              <svg key={i} className="h-6 w-6 text-yellow-400 mx-1" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                              </svg>
                            ))}
                          </div>

                          {/* Quote */}
                          <blockquote className="text-lg lg:text-xl text-gray-700 italic mb-8 leading-relaxed">
                            "{testimonial.content}"
                          </blockquote>

                          {/* Author Info */}
                          <div className="border-t border-gray-200 pt-6">
                            <h4 className="text-xl font-semibold text-gray-900 mb-1">{testimonial.name}</h4>
                            <p className="text-gray-600">{testimonial.role}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`h-3 w-3 rounded-full transition-all duration-200 ${
                    index === currentSlide
                      ? 'bg-blue-600 w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            {/* Progress Bar */}
            <div className="mt-4 max-w-xs mx-auto">
              <div className="bg-gray-200 rounded-full h-1">
                <div
                  className="bg-blue-600 h-1 rounded-full transition-all duration-300"
                  style={{ width: `${((currentSlide + 1) / testimonials.length) * 100}%` }}
                />
              </div>
            </div>
          </div>

          {/* Success Stats */}
          <div className="mt-16 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl shadow-xl">
            <div className="px-8 py-12">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-white mb-8">Thành tích nổi bật</h3>
                <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">100%</div>
                    <div className="text-blue-200">Học sinh đạt điểm 9+ trong kỳ thi vào 10 (2018-2021)</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">100%</div>
                    <div className="text-blue-200">Học sinh lớp 12 năm học 2024-2025 đỗ vào các Đại học top đầu trong nước</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-white mb-2">10+</div>
                    <div className="text-blue-200">Năm kinh nghiệm giảng dạy chuyên sâu</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact/Info Section */}
      {/* <div className="bg-blue-700">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div className="lg:flex lg:items-center lg:justify-between">
            <div>
              <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                Ready to start your English journey?
              </h2>
              <p className="mt-3 text-lg text-blue-200">
                Join hundreds of students who have improved their English skills with our comprehensive program.
              </p>
            </div>
            <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div className="inline-flex rounded-md shadow">
                {isAuthenticated ? (
                  <Link
                    to={user?.role === 'admin' ? '/dashboard' : `/students/${user?.student_id}`}
                    className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 transition-colors"
                  >
                    Go to {user?.role === 'admin' ? 'Dashboard' : 'My Profile'}
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-gray-50 transition-colors"
                  >
                    Đăng nhập
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Footer */}
      <footer className="bg-white">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
          <div className="flex justify-center space-x-6 md:order-2">
            <p className="text-center text-sm text-gray-400">
              Contact us for more information about our English program
            </p>
          </div>
          <div className="mt-8 md:mt-0 md:order-1">
            <p className="text-center text-base text-gray-400">
              &copy; 2024 Cô Loan Tiếng Anh. Empowering students through language education.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};
